import { AssociateCourseCreate } from './AssociateCourseCreate';
import { AssociateCourseEdit } from './AssociateCourseEdit';
import AssociateCourseList from './AssociateCourseList';
import { AssociateCourseShow } from './AssociateCourseShow';

export default {
    list: AssociateCourseList,
    create: AssociateCourseCreate,
    edit: AssociateCourseEdit
};
